export default class Device {

    static isMobile() {
        return (/iphone|ipad|ipod|android|opera\smini|opera\smobi|symbian|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    }

    static isAndroid () {
        return navigator.userAgent.toLocaleLowerCase().indexOf('android') > -1;
    }

    static isIos () {
        const userAgent = navigator.userAgent.toLowerCase();
        const iosDevices = ['iphone', 'ipad', 'ipod', 'macintosh'];

        return iosDevices.some(device => userAgent.includes(device));
    }
}